<template>
    <div class="section has-text-centered">

        <div v-if="!userEmail.length" class="columns is-centered">
            <div class="column is-full">
                <p>Parece que no estas logueado como usuario, para continuar necesitamos que 
                    ingreses un email.
                </p>
                <p>
                    En caso de que tengas una cuenta, 
                    <a href="/user/login/?next=/order/steps/" class="is-custom-color has-text-weight-semibold">
                        Inicia sesion para continuar
                        <b-icon icon="user" size="is-small"></b-icon>
                    </a>
                </p>
                
                <b-field label="Email" label-position="on-border" class="m-t-10 has-text-centered">
                    <b-input
                    v-model="data.email"
                    type="email"
                    icon="envelope"
                    required
                    >
                    </b-input>
                </b-field>
            </div>
        </div>

        <div class="columns has-text-left is-multiline">
            <div v-if="!envios.length" class="column is-one-third">
                <b-field label-position="on-border" label="Metodo de envio">
                    <b-select 
                    v-model="data.shipmentMethod"
                    :disabled="disableFields"
                    required 
                    expanded>
                        <option value="retiro">Retiro en local</option>
                        <option value="dac">Envio domicilio / agencia</option>
                    </b-select>
                </b-field>
            </div>
            <div class="column" :class="envios.length ? 'is-half' : 'is-one-third'">
                <b-field label="Nombre*" label-position="on-border">
                    <b-input
                    v-model="data.firstName"
                    :disabled="disableFields"
                    required
                    >
                    </b-input>
                </b-field>
            </div>
            <div class="column" :class="envios.length ? 'is-half' : 'is-one-third'">
                <b-field label="Apellido*" label-position="on-border">
                    <b-input
                    v-model="data.lastName"
                    :disabled="disableFields"
                    required>
                    </b-input>
                </b-field>
            </div>

            <div class="column is-one-third">
                <b-field  label="Localidad/Ciudad*" label-position="on-border">
                    <b-input
                    v-model="data.location"
                    :disabled="disableFields"
                    required>
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Departamento*" label-position="on-border">
                    <b-input
                    v-model="data.region"
                    :disabled="disableFields"
                    required>
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Codigo Postal*" label-position="on-border">
                    <b-input
                    v-model="data.zipCode"
                    :disabled="disableFields"
                    required>
                    </b-input>
                </b-field>
            </div>

            <div class="column is-two-thirds">
                <b-field label="Direccion*" label-position="on-border">
                    <b-input 
                    v-model="data.address"
                    :disabled="disableFields"
                    required>
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Numero domicilio*" label-position="on-border">
                    <b-input
                    v-model="data.number"
                    :disabled="disableFields"
                    required>
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Numero apartamento" message="Opcional" label-position="on-border">
                    <b-input
                    v-model="data.apNumber"
                    :disabled="disableFields">
                    </b-input>
                </b-field>
            </div>
            
            <div class="column is-half-desktop is-one-third-widescreen">
                <b-field label="Tipo Documento de identidad*" label-position="on-border">
                    <b-select 
                    v-model="data.idType"
                    :disabled="disableFields"
                    expanded 
                    required 
                    placeholde="Tipo de ID">
                        <option value="CI">Cedula identidad</option>
                        <option value="P">Pasaporte</option>
                        <option value="O">Otro</option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-half-desktop is-one-third-widescreen">
                <b-field label="Nro. Documento de identidad*" label-position="on-border">
                    <b-input
                    v-model="data.idNumber"
                    :disabled="disableFields"
                    required>
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-third" label-position="on-border">
                <b-field label="Telefono*" label-position="on-border">
                    <b-input 
                    v-model="data.phoneNumber"
                    :disabled="disableFields"
                    required>
                    </b-input>
                </b-field>
            </div>
            <div class="column is-full">
                <b-field label="Observaciones de direccion." message="Opcional" label-position="on-border">
                    <b-input
                    v-model="data.observations"
                    :disabled="disableFields">
                    </b-input>
                </b-field>
            </div>
        </div>

        <Envios v-if="envios.length" :envios="envios" @envioChange="envioChangeHandler"/>
        

        <div v-if="deliveryDateControl == 'True'">
            <DateHandlerRetiros v-if="data.shipmentMethod=='retiro'" @dateDone="companyDateHandler"/>
            <DateHandlerDelivery v-if="data.shipmentMethod=='delivery'" @dateDone="companyDateHandler"/>
        </div>


        <div class="container m-t-20">
            <div class="level has-text-left is-mobile">
                <div class="level-item">
                    <div>
                        <p class="heading">Subtotal</p>
                        <p>UY${{cart.totalInUy}}</p>
                    </div>
                </div>
                <div class="level-item">
                    <div>
                        <p class="heading">Envio</p>
                        <p>
                            <span v-if="shipmentCost > 0">UY$ {{shipmentCost}}</span>
                            <span v-else class="has-text-success">UY$ 0</span>
                        </p>
                    </div>
                </div>
                <div class="level-item">
                    <div>
                        <p class="heading"><strong>Total</strong></p>
                        <p>
                            <strong v-if="orderPlusShipping">UY${{orderPlusShipping}}</strong> 
                            <strong v-else>UY${{cart.totalInUy}}</strong>
                        </p>
                    </div>
                </div>
            </div>

        </div>

        <div class="column">
            <div class="column is-full has-text-centered">
                <b-button
                type="is-custom"
                rounded
                :disabled="isDisabledButton"
                @click="continueStep">
                    Continuar a {{nextSectionName}}
                    <b-icon icon="arrow-right" size="is-small"></b-icon>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import Envios from "./Envios.vue"
import DateHandlerRetiros from "./DateHandlerRetiros.vue"
import DateHandlerDelivery from "./DateHandlerDelivery.vue"
export default {
    components:{
        Envios,
        DateHandlerRetiros,
        DateHandlerDelivery
    },
    props:{
        userEmail:{
            type:String,
            default:""
        },
        userProfile:{
            type:Object,
            default:{}
        },
        envios:{
            type:Array,
            default:new Array([])
        },
        cart:{
            type:Object,
            default:{}
        },
        nextSectionName:{
            type:String,
            default:""
        },
        deliveryDateControl:{
            type:String,
            default:""
        }
    },

    data(){
        return{
            data:{
                email:this.userEmail,
                shipmentMethod:"retiro",
                firstName:"",
                lastName:"",
                location:"",
                region:"",
                address:"",
                number:"",
                phoneNumber:"",
                idNumber:"",
                idType:"CI",
                zipCode:"",
                shipmentModel:"",
                apNumber:"",
                observations:"",
                deliveryDate:null
            },
            selectedBarrio:"",
            shipmentCost:0,
            orderPlusShipping:0,
            invalidDate:[],
            date:"",
        }
    },
    methods:{
        companyDateHandler(data){
            this.date = data.date
            this.data.deliveryDate = data.date
            if(this.data.shipmentMethod=='delivery'){
                this.data.location=data.barrio
                this.selectedBarrio = data.barrio
            }
        },
        continueStep(){
            this.$emit("orderData", this.data, this.shipmentCost)
        },
        envioChangeHandler(data){
            
            this.date = ""
            this.data.deliveryDate = null
            this.data.shipmentMethod = data.method
            this.data.shipmentModel = data.id
            if (data.freeFrom != 0 && this.cart.totalInUy > data.freeFrom){
                this.shipmentCost = 0
            } else {
                this.shipmentCost = parseInt(data.kgCost) * this.cart.totalWeight + parseInt(data.fixedCost)
            }
            this.orderPlusShipping = parseInt(this.cart.totalInUy) + this.shipmentCost
        }
    },
    computed:{
        isDisabledButton(){
            if(this.deliveryDateControl == "True"){
                var initialVal = !this.data.email 
                    || !this.data.shipmentMethod 
                    || !this.data.firstName 
                    || !this.data.lastName
                    || !this.data.location 
                    || !this.data.region
                    || !this.data.address
                    || !this.data.number
                    || !this.data.phoneNumber
                    || !this.data.idNumber
                    || !this.data.idType
                    || !this.data.zipCode
                    || !this.data.shipmentModel
                    || !this.date
                if(this.data.shipmentMethod=='delivery'){
                    var secondVar = !this.selectedBarrio
                    var final = initialVal || secondVar
                    return final
                } else{
                    return initialVal
                }
            }
            if(this.envios.length){
                return !this.data.email 
                    || !this.data.shipmentMethod 
                    || !this.data.firstName 
                    || !this.data.lastName 
                    || !this.data.location
                    || !this.data.region
                    || !this.data.address
                    || !this.data.number
                    || !this.data.phoneNumber
                    || !this.data.idNumber
                    || !this.data.idType
                    || !this.data.zipCode
                    || !this.data.shipmentModel
            } else{
                return !this.data.email 
                || !this.data.shipmentMethod 
                || !this.data.firstName 
                || !this.data.lastName 
                || !this.data.location
                || !this.data.region
                || !this.data.address
                || !this.data.number
                || !this.data.phoneNumber
                || !this.data.idNumber
                || !this.data.idType
                || !this.data.zipCode
            }
            
        },
        disableFields(){
            return !this.data.email || !this.data.email.includes("@") || !this.data.email.includes(".")
        },
        invalidDateComputed(){
            if (this.invalidDate == '1'){
                return [0, 2, 4, 6]
            }
            return [0, 1, 3, 5, 6]
        },
        
    },
    watch:{
        userProfile: function(val){
            if(this.userEmail){
                this.data = {
                email:this.userEmail,
                shipmentMethod:"retiro",
                firstName:val.firstName,
                lastName:val.lastName,
                location:val.location,
                region:val.region,
                address:val.address,
                number:val.number,
                apNumber:val.apNumber,
                phoneNumber:val.phoneNumber,
                idNumber:val.idNumber,
                idType:val.idType,
                zipCode:val.zipCode,
                shipmentModel:""
                }
            }
        },        
    }
}
</script>

<style lang="scss" scoped>
.is-custom-color{
    color:var(--primary);
}
.is-custom{
    color:var(--text-color);
    background:var(--primary);
}
</style>